module.exports = "https://cdn.thelire.com/ins/resource/multi_pic.86a3c34ffba7f1f9508d4bdf5401061f.png";